var moment = require('moment');
var module = angular.module('octopusApp.configuration');

module.controller('AuditIndexController', function($scope, $location, busy, octopusClient, octopusRepository, eventFormatter, octopusPermissionSet, octopusTagSets, $q, $uibModal) {
    var vm = this;
    var isLoading = vm.isLoading = $scope.isLoading = busy.create();
    var dateFormat = 'YYYY-MM-DDTHH:mm:ss.Z'; // This matches the server-side date format for subscription notification deep links, play carefully!

    vm.openFilterDialog = openFilterDialog;
    vm.availableTenants = [];
    vm.tenantPromotions = {};
    vm.dashboardFilter = {
        showAll: true,
        selectedUsers: [],
        selectedProjects: [],
        selectedEnvironments: [],
        selectedEventGroups: [],
        selectedEventCategories: [],
        selectedTags: [],
        selectedTenants: [],
        selectedDocumentTypes: [],
        dates: {
            startDate: moment().subtract(30, 'days').startOf('day'),
            endDate: moment().add(1, 'day').startOf('day').subtract(1, 'seconds')
        },
        skip: 0
    };
    vm.isFiltered = false;
    vm.clearFilters = false;
    vm.wasLoaded = false;
    vm.exportUrl = '';

    var clearAllFilters = function () {
        vm.dashboardFilter.selectedUsers = [];
        vm.dashboardFilter.selectedProjects = [];
        vm.dashboardFilter.selectedEnvironments = [];
        vm.dashboardFilter.selectedEventGroups = [];
        vm.dashboardFilter.selectedEventCategories = [];
        vm.dashboardFilter.selectedTags = [];
        vm.dashboardFilter.selectedTenants = [];
        vm.dashboardFilter.selectedDocumentTypes = [];
        vm.dashboardFilter.dates.startDate = moment().subtract(30, 'days').startOf('day');
        vm.dashboardFilter.dates.endDate = moment().add(1, 'day').startOf('day').subtract('seconds', 1);
        vm.isFiltered = false;
        $location.search("users", null);
        $location.search("projects", null);
        $location.search("environments", null);
        $location.search("eventGroups", null);
        $location.search("eventCategories", null);
        $location.search("tenants", null);
        $location.search("tags", null);
        $location.search("documentTypes", null);
        $location.search("from", null);
        $location.search("to", null);
        vm.refresh();
        return false;
    };

    function extractFilterParams() {
        vm.isFiltered = false; // reset
        if ($location.search().users){
            var usersVal = $location.search().users;
            if (typeof usersVal === "string") {
                usersVal = [usersVal];
            }
            vm.dashboardFilter.selectedUsers = usersVal;
            vm.isFiltered = true;
        }
        if ($location.search().projects){
            var projectsVal = $location.search().projects;
            if (typeof projectsVal === "string") {
                projectsVal = [projectsVal];
            }
            vm.dashboardFilter.selectedProjects = projectsVal;
            vm.isFiltered = true;
        }
        if ($location.search().environments){
            var environmentsVal = $location.search().environments;
            if (typeof environmentsVal === "string") {
                environmentsVal = [environmentsVal];
            }
            vm.dashboardFilter.selectedEnvironments = environmentsVal;
            vm.isFiltered = true;
        }
        if ($location.search().eventGroups){
            var eventGroupsVal = $location.search().eventGroups;
            if (typeof eventGroupsVal === "string") {
                eventGroupsVal = [eventGroupsVal];
            }
            vm.dashboardFilter.selectedEventGroups = eventGroupsVal;
            vm.isFiltered = true;
        }
        if ($location.search().eventCategories){
            var eventCategoriesVal = $location.search().eventCategories;
            if (typeof eventCategoriesVal === "string") {
                eventCategoriesVal = [eventCategoriesVal];
            }
            vm.dashboardFilter.selectedEventCategories = eventCategoriesVal;
            vm.isFiltered = true;
        }
        if ($location.search().tenants){
            var tenantVal = $location.search().tenants;
            if (typeof tenantVal === "string") {
                tenantVal = [tenantVal];
            }
            vm.dashboardFilter.selectedTenants = tenantVal;
            vm.isFiltered = true;
        }
        if ($location.search().tags){
            var tagVal = $location.search().tags;
            if (typeof tagVal === "string") {
                tagVal = [tagVal];
            }
            vm.dashboardFilter.selectedTags = tagVal;
            vm.isFiltered = true;
        }
        if ($location.search().documentTypes){
            var documentTypeVal = $location.search().documentTypes;
            if(typeof documentType === "string") {
                documentTypeVal = [documentTypeVal];
            }
            vm.dashboardFilter.selectedDocumentTypes = documentTypeVal;
            vm.isFiltered = true;
        }
        if ($location.search().from){
            var fromVal = $location.search().from;
            if (typeof fromVal === "string") {
                fromVal = [fromVal];
            }
            vm.dashboardFilter.dates.startDate = moment(fromVal, dateFormat);
            // This setting is not part of the filter dialog, so do not set vm.isFiltered here.
        }
        if ($location.search().to){
            var toVal = $location.search().to;
            if (typeof toVal === "string") {
                toVal = [toVal];
            }
            vm.dashboardFilter.dates.endDate = moment(toVal, dateFormat);
            // This setting is not part of the filter dialog, so do not set vm.isFiltered here.
        }
    }

    function openFilterDialog() {
        if (vm.clearFilters) {
            clearAllFilters();
            vm.clearFilters = false;
            return;
        }

        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/configuration/audit/views/audit_filter_dialog.html',
            controller: 'AuditFilterDialogController',
            controllerAs: 'vm',
            bindToController: true,
            resolve: {
                selectedValues: function () {
                    return {
                        selectedUsers: vm.dashboardFilter.selectedUsers,
                        selectedProjects: vm.dashboardFilter.selectedProjects,
                        selectedEnvironments: vm.dashboardFilter.selectedEnvironments,
                        selectedEventGroups: vm.dashboardFilter.selectedEventGroups,
                        selectedEventCategories: vm.dashboardFilter.selectedEventCategories,
                        selectedTenants: vm.dashboardFilter.selectedTenants,
                        selectedTags: vm.dashboardFilter.selectedTags,
                        selectedDocumentTypes: vm.dashboardFilter.selectedDocumentTypes
                    };
                },
                visibleTenantFilter: function () {
                    return function (tenant) {
                        return false;
                    };
                }
            }
        }).result.then(function (result) {
            if (!result) {
                return;
            }
            vm.dashboardFilter.selectedUsers = result.selectedUsers;
            vm.dashboardFilter.selectedProjects = result.selectedProjects;
            vm.dashboardFilter.selectedEnvironments = result.selectedEnvironments;
            vm.dashboardFilter.selectedEventGroups = result.selectedEventGroups;
            vm.dashboardFilter.selectedEventCategories = result.selectedEventCategories;
            vm.dashboardFilter.selectedTenants = result.selectedTenants;
            vm.dashboardFilter.selectedTags = result.selectedTags;
            vm.dashboardFilter.selectedDocumentTypes = result.selectedDocumentTypes;
            vm.isFiltered = result.selectedUsers.length > 0
             || result.selectedProjects.length > 0
             || result.selectedEnvironments.length > 0
             || result.selectedEventGroups.length > 0
             || result.selectedEventCategories.length > 0
             || result.selectedTenants.length > 0
             || result.selectedTags.length > 0
             || result.selectedDocumentTypes.length > 0;

            if (vm.dashboardFilter.selectedUsers && vm.dashboardFilter.selectedUsers.length > 0) {
                $location.search('users', vm.dashboardFilter.selectedUsers);
            } else {
                $location.search('users', undefined);
            }

            if (vm.dashboardFilter.selectedProjects && vm.dashboardFilter.selectedProjects.length > 0) {
                $location.search('projects', vm.dashboardFilter.selectedProjects);
            } else {
                $location.search('projects', undefined);
            }

            if (vm.dashboardFilter.selectedEnvironments && vm.dashboardFilter.selectedEnvironments.length > 0) {
                $location.search('environments', vm.dashboardFilter.selectedEnvironments);
            } else {
                $location.search('environments', undefined);
            }

            if (vm.dashboardFilter.selectedEventGroups && vm.dashboardFilter.selectedEventGroups.length > 0) {
                $location.search('eventGroups', vm.dashboardFilter.selectedEventGroups);
            } else {
                $location.search('eventGroups', undefined);
            }

            if (vm.dashboardFilter.selectedEventCategories && vm.dashboardFilter.selectedEventCategories.length > 0) {
                $location.search('eventCategories', vm.dashboardFilter.selectedEventCategories);
            } else {
                $location.search('eventCategories', undefined);
            }

            if (vm.dashboardFilter.selectedTenants && vm.dashboardFilter.selectedTenants.length > 0) {
                $location.search('tenants', vm.dashboardFilter.selectedTenants);
            } else {
                $location.search('tenants', undefined);
            }

            if (vm.dashboardFilter.selectedTags && vm.dashboardFilter.selectedTags.length > 0) {
                $location.search('tags', vm.dashboardFilter.selectedTags);
            } else {
                $location.search('tags', undefined);
            }

            if (vm.dashboardFilter.selectedDocumentTypes && vm.dashboardFilter.selectedDocumentTypes.length > 0) {
                $location.search('documentTypes', vm.dashboardFilter.selectedDocumentTypes);
            } else {
                $location.search('documentTypes', undefined);
            }

            vm.refresh();
        });
    }

    vm.selectPage = function(skip) {
        vm.dashboardFilter.skip = skip;
        reload();
    };

    vm.refresh = function() {
        vm.dashboardFilter.skip = 0;
        reload();
    };

    vm.refreshDates = function() {
        if (vm.dashboardFilter.dates.startDate) {
            $location.search('from', vm.dashboardFilter.dates.startDate.utc().format(dateFormat));
        } else {
            $location.search('from', undefined);
        }

        if (vm.dashboardFilter.dates.endDate) {
            $location.search('to', vm.dashboardFilter.dates.endDate.utc().format(dateFormat));
        } else {
            $location.search('to', undefined);
        }

        vm.refresh();
    };

    vm.openSubscriptions = function() {
        $location.path('/configuration/subscriptions')
            .search('users', null)
            .search('projects', null)
            .search('environments', null)
            .search('eventGroups', null)
            .search('eventCategories', null)
            .search('tags', null)
            .search('tenants', null)
            .search('documentTypes', null);
    };

    vm.openNewSubscription = function() {
        $location.path('/configuration/subscriptions/new')
            .search('users', vm.dashboardFilter.selectedUsers)
            .search('projects', vm.dashboardFilter.selectedProjects)
            .search('environments', vm.dashboardFilter.selectedEnvironments)
            .search('eventGroups', vm.dashboardFilter.selectedEventGroups)
            .search('eventCategories', vm.dashboardFilter.selectedEventCategories)
            .search('tags', vm.dashboardFilter.selectedTags)
            .search('tenants', vm.dashboardFilter.selectedTenants)
            .search('documentTypes', vm.dashboardFilter.selectedDocumentTypes);
    };

    var reload = function() {
      if(!vm.wasLoaded) {
          return;
      }
      extractFilterParams();
      var eventListOptions = {};

      if (vm.dashboardFilter.selectedUsers) {
          eventListOptions.users = vm.dashboardFilter.selectedUsers;
      }
      if (vm.dashboardFilter.selectedProjects) {
          eventListOptions.projects = vm.dashboardFilter.selectedProjects;
      }
      if (vm.dashboardFilter.selectedEnvironments) {
          eventListOptions.environments = vm.dashboardFilter.selectedEnvironments;
      }
      if (vm.dashboardFilter.selectedEventGroups) {
          eventListOptions.eventGroups = vm.dashboardFilter.selectedEventGroups;
      }
      if (vm.dashboardFilter.selectedEventCategories) {
          eventListOptions.eventCategories = vm.dashboardFilter.selectedEventCategories;
      }
      if (vm.dashboardFilter.selectedTags) {
          eventListOptions.tags = vm.dashboardFilter.selectedTags;
      }
      if (vm.dashboardFilter.selectedTenants) {
          eventListOptions.tenants = vm.dashboardFilter.selectedTenants;
      }
      if (vm.dashboardFilter.selectedDocumentTypes) {
          eventListOptions.documentTypes = vm.dashboardFilter.selectedDocumentTypes;
      }
      if (vm.dashboardFilter.dates.startDate) {
          eventListOptions.from = vm.dashboardFilter.dates.startDate.format();
      }
      if (vm.dashboardFilter.dates.endDate) {
          eventListOptions.to = vm.dashboardFilter.dates.endDate.format();
      }
      if (vm.dashboardFilter.skip) {
          eventListOptions.skip = vm.dashboardFilter.skip;
      }

      isLoading.promise(octopusRepository.Events.list(eventListOptions).then(function(events){
          vm.events = events;
          eventListOptions.asCsv = true;
          vm.exportUrl = octopusClient.resolveLinkTemplate("Events", eventListOptions);
      }));
    };

    function init(){
        var perm = 'AuditView';
        octopusPermissionSet.isAuthorized({ permission: perm }).then(function(yn) {
            if(yn) {
                extractFilterParams();
                vm.wasLoaded  = true;
                vm.refresh();
            } else {
                isLoading.showError("You do not have permission to perform this action. Please contact your Octopus administrator. Missing permission: " + perm);
            }
        });
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/controllers/audit_index_controller.js
// module id = 8886946398724636
// module chunks = 1